import type { Schema } from "@loanlink-nl/zero";
import type { Row } from "@rocicorp/zero";
import type { ComputedRef, InjectionKey, Ref } from "vue";

export const conversationKey = Symbol() as InjectionKey<
	Ref<Row<Schema["tables"]["conversationTable"]> | undefined>
>;

export interface PropertyFieldContext<T = unknown> {
	value: ComputedRef<T>;
	setValue: (value: T) => void;
	isActive: (sourceValue: T) => boolean;
}

export const propertyFieldKey = Symbol(
	"propertyField",
) as InjectionKey<PropertyFieldContext>;
